import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { PageLayoutComponent } from '../../../components/shared/page-layout/page-layout.component';

@Component({
  selector: 'app-assurance-flotte-moto-professionnelle',
  standalone: true,
  imports: [CommonModule, RouterModule, PageLayoutComponent],
  templateUrl: './assurance-flotte-moto-professionnelle.component.html',
  styleUrls: ['./assurance-flotte-moto-professionnelle.component.scss']
})
export class AssuranceFlotteMotoProfessionnelleComponent {
  title = 'Assurance Flotte Moto Professionnelle';
  subtitle = '';
  heroImage = 'assets/static_pages_images/MotoPersonnelle.jpg';

  breadcrumbs = [
    { label: 'Entreprises', link: undefined },
    { label: 'Assurance Flotte Moto Professionnelle', link: undefined }
  ];

  prevPage = { 
    title: 'Assurance Flotte Auto Professionnelle',
    link: '/assurance-flotte-automobile'
  };

  nextPage = { 
    title: 'Assurance Multirisque Professionnelle',
    link: '/assurance-multirisque-pro'
  };

  partners = [
    { name: 'GENERALI', logo: 'assets/partners/generali.png' },
    { name: 'AMV', logo: 'assets/partners/amv.png' },
    { name: 'MUTUELLE DES MOTARDS', logo: 'assets/partners/mutuelle-motards.png' },
    { name: 'SIMPLE', logo: 'assets/partners/simple.png' },
    { name: 'XENASSUR', logo: 'assets/partners/xenassur.png' },
    { name: 'PROGEAS', logo: 'assets/partners/progeas.png' }
  ];
}
